import { Request } from 'crono-fe-common/types/request';
import client from 'utils/clients/client';
import { ENDPOINTS } from '../../../config/endpoints';
import { CustomEmailProviderSettings } from 'crono-fe-common/types/customEmailProviderSettings';

export type CustomEmailProviderVerifyIntegrationResult = {
  data: { isSuccess: boolean; data: CustomEmailProviderSettings | null };
};

class CustomEmailProviderService {
  private _alreadyRunningVerifyCustomEmailProviderIntegrationCall: Promise<CustomEmailProviderVerifyIntegrationResult> | null =
    null;

  public async verifyCustomEmailProviderIntegration(
    email: string,
  ): Promise<CustomEmailProviderVerifyIntegrationResult> {
    if (this._alreadyRunningVerifyCustomEmailProviderIntegrationCall) {
      return await this._alreadyRunningVerifyCustomEmailProviderIntegrationCall;
    } else {
      this._alreadyRunningVerifyCustomEmailProviderIntegrationCall =
        this._verifyCustomEmailProviderIntegration(email);
      try {
        const verifyResult =
          await this._alreadyRunningVerifyCustomEmailProviderIntegrationCall;
        return verifyResult;
      } catch (e) {
        return {
          data: {
            isSuccess: false,
            data: null,
          },
        };
      } finally {
        this._alreadyRunningVerifyCustomEmailProviderIntegrationCall = null;
      }
    }
  }

  private async _verifyCustomEmailProviderIntegration(
    email: string,
  ): Promise<CustomEmailProviderVerifyIntegrationResult> {
    const request: Request = {
      url: ENDPOINTS.customEmailProvider.verify,
      config: {
        method: 'POST',
        data: {
          email,
        },
      },
    };

    const result = await client(request);
    return result as CustomEmailProviderVerifyIntegrationResult;
  }
}

// I export a single instance of the service, so that all other files that import
// this file will always import the same instance
export default new CustomEmailProviderService();
